import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function ScrollTo() {
  const { section } = useParams<{ section: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (section) {
      // Guardar la sección en sessionStorage para que Home la lea
      sessionStorage.setItem('scrollToSection', section);
      // Navegar a Home
      navigate('/', { replace: true });
    }
  }, [section, navigate]);

  return null;
}

